// src/components/LanguageSelector/index.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe, Check } from 'lucide-react';
import './index.css';

const languages = [
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'French', nativeName: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'German', nativeName: 'Deutsch', flag: '🇩🇪' },
  { code: 'zh', name: 'Chinese', nativeName: '中文', flag: '🇨🇳' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी', flag: '🇮🇳' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', flag: '🇸🇦' }
];

const LanguageSelector = () => {
  const { i18n, t } = useTranslation();
  const [showDropdown, setShowDropdown] = useState(false);

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('preferredLanguage', langCode);
    setShowDropdown(false);
  };

  return (
    <div className="language-selector">
      <button
        className="language-selector-button"
        onClick={() => setShowDropdown(!showDropdown)}
      >
        <Globe size={18} />
        <span className="language-selector-text">
          {currentLanguage.flag} {currentLanguage.nativeName}
        </span>
      </button>

      {showDropdown && (
        <>
          <div 
            className="language-selector-overlay" 
            onClick={() => setShowDropdown(false)}
          />
          <div className="language-selector-dropdown">
            <div className="language-selector-header">
              <h3>{t('preferences.selectLanguage')}</h3>
            </div>
            <div className="language-selector-list">
              {languages.map(lang => (
                <button
                  key={lang.code}
                  className={`language-selector-item ${
                    i18n.language === lang.code ? 'active' : ''
                  }`}
                  onClick={() => changeLanguage(lang.code)}
                >
                  <span className="language-flag">{lang.flag}</span>
                  <div className="language-names">
                    <span className="language-native">{lang.nativeName}</span>
                    <span className="language-english">{lang.name}</span>
                  </div>
                  {i18n.language === lang.code && (
                    <Check size={18} className="language-check" />
                  )}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSelector;